import React from "react";

const Article = ({ author, cat, image, link, title }) => {
  const formatedAuthorString = author.map((name, index) => (index === 0 ? name : !!name ? ` - ${name} ` : "")).join("");

  return (
    <article className="insight">
      <a href={link}>
        <div className="insight__grid">
          <div className="insight__grid-content">
            {cat && <span className="kicker">{cat}</span>}
            <h3>{title}</h3>
            {author && <span className="author">by {formatedAuthorString}</span>}
          </div>
          <div className="insight__grid-image">
            {image.src && (
              <>
                <div className="padding"></div>
                <div
                  className="image__image"
                  style={{
                    background: `url(${image.src}) no-repeat center center`,
                    backgroundSize: `cover`,
                  }}
                />
              </>
            )}
          </div>
        </div>
      </a>
    </article>
  );
};

export default Article;
